import { Centrifuge } from 'centrifuge';
import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  centrifugeConnectionConnecting,
  centrifugeConnectionFailed,
  centrifugeConnectionSuccessful,
  getCentrifugeToken,
} from '../actions';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CENTRIFUGE_URL } from '../../../configs';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

window.centrifugeConnection = null;
window.centrifugeSubscriptions = [];
export default function* centrifugeConnection(action) {
  const { dispatch } = window.appStore;
  try {
    if (!window.centrifugeConnection) {
      const centrifugeRequest = yield put(getCentrifugeToken());
      const data = yield centrifugeRequest;
      window.centrifugeConnection = new Centrifuge(data.wsUrl, {
        token: data.token,
        debug: true,
      });

      window.centrifugeConnection.on('connecting', ctx => {
        dispatch(centrifugeConnectionConnecting());
      });

      const p = new Promise((resolve, reject) => {
        window.centrifugeConnection.on('connected', ctx => {
          // log('✅ Подключено к Centrifugo (user: ' + ctx.client + ')', 'info');
          dispatch(centrifugeConnectionSuccessful());
          resolve(true);
        });
        window.centrifugeConnection.on('disconnected', ctx => {
          dispatch(centrifugeConnectionFailed());
          resolve(false);
        });
      });
      window.centrifugeConnection.on('error', ctx => {
        window.console.error(ctx.error?.message || 'Unknown');
        dispatch(centrifugeConnectionFailed());
      });
      window.centrifugeConnection.connect();

      const res = yield p;
      if (res) {
        yield call(resolveActionPromise(action));
      } else {
        yield call(rejectActionPromise(action));
      }
    } else {
      yield call(resolveActionPromise(action));
    }
  } catch (e) {
    yield put(centrifugeConnectionFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
